module.exports = __webpack_public_path__ + "static/media/mini.e144f135.png";


//////////////////
// WEBPACK FOOTER
// ./src/marketingOnline/data/carImages/远程星智/mini.png
// module id = 687
// module chunks = 0